<template>
  <div>
    <el-form :model="form" :inline="true" size="small" :ref="`ruleForm`" :rules="rule">
      <el-form-item label="出货时间" prop="shipmentTime">
        <el-date-picker
          v-model="form.shipmentTime"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="出货数量" prop="shipmentCount">
        <el-input v-model.trim="form.shipmentCount" placeholder=""></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: ['data', 'packCode'],
  data() {
    const checkDate = (rule, value, callback) => {
      let now = moment(new Date()).format('YYYYMMDD') + '000000';
      value = moment(value).format('YYYYMMDDHHmmss')
      if(now < value || now === value) {
        callback()
      }else{
        callback(new Error('出货时间应大于当前日期'));
      }
    }
    const checkInt = (rule, value, callback) => {
      let reg = /^[+]{0,1}(\d+)$/;
      if(reg.test(value)) {
        callback()
      }else{
        callback(new Error('出货数量应是正整数'));
      }
    }
    return {
      form: {},
      rule: {
        shipmentTime: [
          { required: true, trigger: 'change', validator: checkDate }
        ],
        shipmentCount: [
          { required: true, trigger: 'change', validator: checkInt }
        ],
      }
    }
  },
  computed: {
    formData() {
      return this.data;
    }
  },
  mounted() {
    this.form = {
      id: this.formData.id,
      shipmentTime: this.formData.shipmentTime,
      shipmentCount: this.formData.shipmentCount,
      packCode: this.packCode
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>> .el-input, .el-input__inner
    width 130px

  >>> .el-form-item--small.el-form-item
    margin-bottom 10px !important

  >>> .el-checkbox, >>> .el-radio
    margin-right 10px
</style>